import 'stylesheets/news';

window.addEventListener("load", (event) => {
  load();
});
